import { dispatchAction } from '@ardoq/rxbeach';
import { setIsViewExporting, viewExportSucceeded } from './actions';
import { ViewIds } from '@ardoq/api-types';
import { isExportCapturing } from './exportSink';

const notifyExportStarted = (viewId: ViewIds) => {
  dispatchAction(setIsViewExporting({ isExporting: true }), viewId);
};

const notifyExportFinished = (viewId: ViewIds) => {
  dispatchAction(setIsViewExporting({ isExporting: false }), viewId);
};

/** Records a view export the user saved; captured or dropped exports are not recorded. */
const notifyExportSucceeded = (viewId: ViewIds) => {
  if (isExportCapturing()) {
    return;
  }
  dispatchAction(viewExportSucceeded(viewId));
};

export const viewExportCommands = {
  notifyExportStarted,
  notifyExportFinished,
  notifyExportSucceeded,
};
